import React, { useState, createContext, useContext } from 'react';

const HomeContext = createContext();

export const HomeProvider = ({ children }) => {
  const [showSignInBox, setShowSignInBox] = useState(false);
  const [showSignUpBox, setShowSignUpBox] = useState(false);

  return (
    <HomeContext.Provider
      value={{
        showSignInBox,
        setShowSignInBox,
        showSignUpBox,
        setShowSignUpBox,
      }}
    >
      {children}
    </HomeContext.Provider>
  );
};

export const useHomeContext = () => useContext(HomeContext);
